export default {
    modal: {
        approve: 'Согласование',
        reject: 'Отклонение',
        cancel: 'Аннулирование',
        annul: 'Аннулирование',
        comment: 'Комментарий',
        close_all_modals: 'Закрыть все модальные окна?',
        close_yes: 'Да',
        close_no: 'Нет',
        enable_push: 'Подключить уведомления в браузере?',
        enable: 'Подключить',
        deny: 'Отклонить',
        close_all: 'закрыть все',
        opened: 'Открытые окна',
        logoutQuestion: 'Вы авторизованы, для регистрации требуется выйти из учетной записи',
        cancelModal: 'Отмена',
    }
}
